import { c as _c } from "react/compiler-runtime";
import type { MarketId } from '@morpho-org/blue-sdk';
import { useWeb3Context } from '@/contexts/Web3Context';
import { useFeatureFlags } from '@/lib/shared/components/FeatureFlagsProvider';
import { isMarketLendFlowEnabled } from '@/lib/shared/utils/flags.constants';
import { useLendAction } from '../../PositionManager/PositionManagerLendDialog/useLendAction';
import { useLendWithdrawAction } from '../../PositionManager/PositionManagerLendWithdrawDialog/useLendWithdrawAction';
interface UseMobileLendCardInput {
  marketId: MarketId;
  chainId: number;
  /** False when browsing another address's portfolio — that position isn't actionable. */
  isSelf: boolean;
  /** One position per side. `undefined` while the answer has not landed. */
  hasBorrowPosition: boolean | undefined;
}

/**
 * Lend and Withdraw actions for the portfolio lend card on mobile, where the lend table is
 * replaced by cards that render no row actions. Adds the gate the table gets from column
 * visibility: the flags, and ownership of the position.
 */
export const useMobileLendCard = t0 => {
  const $ = _c(15);
  const {
    marketId,
    chainId,
    isSelf,
    hasBorrowPosition
  } = t0;
  const flags = useFeatureFlags();
  const {
    account
  } = useWeb3Context();
  let t1;
  if ($[0] !== chainId || $[1] !== marketId) {
    t1 = {
      marketId,
      chainId,
      fullSize: true,
      source: "lend_card"
    };
    $[0] = chainId;
    $[1] = marketId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    onWithdrawClick
  } = useLendWithdrawAction(t1);
  let t2;
  if ($[3] !== chainId || $[4] !== marketId) {
    t2 = {
      marketId,
      chainId,
      fullSize: true,
      source: "lend_card"
    };
    $[3] = chainId;
    $[4] = marketId;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    onLendClick
  } = useLendAction(t2);
  const isOwner = account.isConnected && isSelf;
  const t3 = flags.marketLendPosition && isOwner;
  let t4;
  if ($[6] !== flags || $[7] !== hasBorrowPosition || $[8] !== isOwner) {
    t4 = isMarketLendFlowEnabled(flags) && isOwner && hasBorrowPosition === false;
    $[6] = flags;
    $[7] = hasBorrowPosition;
    $[8] = isOwner;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== onLendClick || $[11] !== onWithdrawClick || $[12] !== t3 || $[13] !== t4) {
    t5 = {
      onWithdrawClick,
      onLendClick,
      canWithdraw: t3,
      canLend: t4
    };
    $[10] = onLendClick;
    $[11] = onWithdrawClick;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};